import {
  Component,
  EventEmitter,
  forwardRef,
  Host,
  HostBinding,
  Input,
  OnInit,
  Optional,
  Output,
  SkipSelf,
  ViewChild,
} from '@angular/core';
import { AbstractControl, ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { EditorComponent as TinyMceEditor } from '@tinymce/tinymce-angular';
import { UtilitiesService } from 'app/store/services/utilities.servive';

@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EditorComponent),
      multi: true,
    },
  ],
})
export class EditorComponent implements OnInit {

  @Input() initOverrides: any;

  @Input() plugins = 'link lists';

  @Input() toolbar = 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist';

  @Input() formControlName;

  @Output() ready: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild(TinyMceEditor, { static: false }) editorComponent: TinyMceEditor;

  init: any = {
    indent: false,
    contextmenu: false,
    base_url: '/tinymce',  // For self-hosted
    suffix: '.min',
    promotion: false,
  };

  value = '';
  disabled: boolean;
  apiKey: string;
  componentReady = false;
  initReady: boolean;
  control: AbstractControl | null = null;

  constructor(
    @Optional()
    @Host()
    @SkipSelf()
    private controlContainer: ControlContainer,
    private readonly utilitiesService: UtilitiesService,
  ) {
    this.apiKey = environment.tinyMceAPIKey;
  }

  get editor(): TinyMceEditor {
    return this.editorComponent;
  }

  @HostBinding('class.ng-invalid') get hasError() {
    return (this.control?.touched || this.control?.dirty) && this.control?.invalid;
  }

  insertContent(content: string) {
    this.editor.editor.insertContent(content);
  }

  getTestId(predefined?: string) {
    if (predefined) {
      return this.utilitiesService.getTestIdProp(`${predefined}-editor`);
    }

    if (typeof this.formControlName === "string") {
      return this.utilitiesService.getTestIdProp(`${this.formControlName}-editor`);
    }

    return this.utilitiesService.getTestIdProp('editor');
  }

  ngOnInit() {

    if (this.controlContainer != null && this.formControlName) {
      this.control = this.controlContainer.control.get(this.formControlName);
    }
    this.init = {
      ...this.init,
      plugins: this.plugins,
      toolbar: this.toolbar,
    };
    if (this.initOverrides && Object.keys(this.initOverrides).length > 0) {
      this.init = {
        ...this.init,
        ...this.initOverrides,
      };
      if (this.init.toolbar) {
        this.toolbar = this.init.toolbar;
      }
    }
    console.log('here 1', this.init, this.plugins);
    this.initReady = true;
  }

  // Called when model value changes
  onChangeHandler(content: string) {
    this.value = content;
    this.onChange(content);
  }

  // ControlValueAccessor methods
  writeValue(value: string): void {
    this.value = value || '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }

  onInit(): void {
    this.componentReady = true;
    this.ready.emit(true);
    // this.eventService.broadcast(EVENT_LOAD_TINYMCE_PLUGINS, true);
  }

  private onChange = (_: any) => {
  };

  private onTouched = () => {
  };

}
